import { UIText2 } from '@cian/ui-kit';
import { IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as style from './BookedOverlay.css';

export const BookedOverlay: React.FC = () => {
  return (
    <div className={style['container']}>
      <div className={style['icon']}>
        <IconFunctionalLock16 />
      </div>
      <UIText2 fontWeight="700">Квартира забронирована</UIText2>
    </div>
  );
};
